import LogoImg from '../../assets/logo.png';

const LogoFull = () => {
  return (
    // Add png image here
    <img src={LogoImg} alt="Logo" 
    style={{ 
      width: '120px', 
      height: '80px',
      objectFit: 'contain', // Preserves aspect ratio
      marginRight: '10px'   // Adds spacing
    }} 
    />
  );
};

export default LogoFull;
